import { Container, Graphics } from 'pixi.js';
import { getLocalizedValue } from '@softgames/localization';
import { TournamentEntryLayout } from '../../../layouts/mainMenu/tournament/TournamentEntryLayout';
import { insertAvatar } from '../../game/utils/insertAvatar';
import type { LeaderboardEntry } from '../../app/platform/Platform';

export class TournamentEntryView extends Container {
  private readonly layout = new TournamentEntryLayout();

  constructor() {
    super();
    this.init();
  }

  private init(): void {
    const { avatar, root } = this.layout;

    root.props({
      parent: this,
    });

    avatar.mask = new Graphics()
      .circle(avatar.x, avatar.y, avatar.width * 0.5)
      .fill({ color: 'black', alpha: 1 })
      .props({
        parent: avatar.parent,
      });
  }

  public setEntry(entry: LeaderboardEntry | null): this {
    if (!entry) {
      this.setNoEntry();
      return this;
    }
    const { avatar, name, score, scoreTrophy } = this.layout;
    if (entry.player.avatarUrl) {
      console.log(entry.player.avatarUrl);
      void insertAvatar(avatar, entry.player.avatarUrl);
    }
    name.text = entry.player.name;
    score.text = entry.score > 0 ? getLocalizedValue(entry.score) : '???';
    this.updateMedal(entry.rank);
    scoreTrophy.x = score.x - score.width - 30;
    return this;
  }

  private setNoEntry(): void {
    const { avatar, name, score, scoreTrophy, medal, medalText } = this.layout;
    avatar.props({
      texture: 'avatar_placeholder',
    });
    name.text = '-';
    score.text = '-';
    scoreTrophy.x = score.x - score.width - 30;
    medal.props({
      texture: 'Tournament_Unknown_Medal',
    });
    medalText.props({
      visible: true,
      text: '?',
    });
  }

  private updateMedal(rank: number): void {
    const { medal, medalText } = this.layout;

    const texture =
      ['Tournament_Gold_Medal', 'Tournament_Silver_Medal', 'Tournament_Bronze_Medal'][rank - 1] ??
      'Tournament_Unknown_Medal';
    medal.props({
      texture,
    });

    medalText.props({
      visible: rank > 3 || rank === -1,
      text: `${rank > -1 ? rank : '?'}`,
    });
  }
}
